import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceSelectionService {
  private selectedDevice: any = null;

  setSelectedDevice(device: any) {
    this.selectedDevice = device;
  }

  getSelectedDevice() {
    return this.selectedDevice;
  }

  clearSelectedDevice() {
    this.selectedDevice = null;
  }
}
